'use strict';

// Import module
import './module/sphere';
// Sass Import
import '../Sass/style.scss';
